module.exports = __webpack_public_path__ + "img/08219203001238.8de0b9c6.png";